module.exports = __webpack_public_path__ + "static/img/13.635e38b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/13.png
// module id = 2eKi
// module chunks = 0